import { getTradingAccounts, decryptResponseMessages } from "../../utils/apiClient";
import { AccountType } from "../../utils/enums";

/**
 * Fetches demo trading accounts from the API
 * @param {number} perPage - Number of accounts per page (default: 6)
 * @param {number} page - Page number (default: 1)
 * @param {string|null} searchTerm - Optional search term
 * @returns {Promise<{accounts: Array, total: number, error: boolean}>}
 */
const getDemoAccounts = async (perPage = 6, page = 1, searchTerm = null) => {
  try {
    const response = await getTradingAccounts(AccountType.DEMO, perPage, page, searchTerm);

    const decryptedData =
      response.decryptedData ||
      (await decryptResponseMessages(response.data)) ||
      response.data;

    // Extract accounts data from response
    let accountsData = [];
    let total = 0;

    if (decryptedData) {
      // ACCOUNT_LIMIT comes from dashboard API, not from trading accounts API
      // So we don't extract it here
      
      // Check various possible response structures
      if (decryptedData.DATA && Array.isArray(decryptedData.DATA)) {
        accountsData = decryptedData.DATA;
        total = decryptedData.TOTAL || decryptedData.total || accountsData.length;
      } else if (decryptedData.DATA && !Array.isArray(decryptedData.DATA)) {
        accountsData = [decryptedData.DATA];
        total = decryptedData.TOTAL || decryptedData.total || 1;
      } else if (Array.isArray(decryptedData)) {
        accountsData = decryptedData;
        total = decryptedData.length;
      } else if (decryptedData.accounts && Array.isArray(decryptedData.accounts)) {
        accountsData = decryptedData.accounts;
        total = decryptedData.total || decryptedData.TOTAL || accountsData.length;
      } else if (decryptedData.data && Array.isArray(decryptedData.data)) {
        accountsData = decryptedData.data;
        total = decryptedData.total || decryptedData.TOTAL || accountsData.length;
      }
    }

    return {
      accounts: accountsData,
      total: total || accountsData.length,
      error: false,
    };
  } catch (error) {
    return {
      accounts: [],
      total: 0,
      error: true,
    };
  }
};

export default {
  getDemoAccounts,
};
